<script setup>
import { useI18n } from 'vue-i18n';
import { formatDateTime } from '../helpers';

defineProps({
  events: { type: Array, default: () => [] },
});
const { t, locale } = useI18n();

const ICONS = {
  created: 'i-lucide-plus',
  updated: 'i-lucide-pencil',
  scheduled: 'i-lucide-calendar-clock',
  unscheduled: 'i-lucide-calendar-off',
  started: 'i-lucide-play',
  paused: 'i-lucide-pause',
  resumed: 'i-lucide-play',
  cancelled: 'i-lucide-x-circle',
  completed: 'i-lucide-check-circle-2',
  failed: 'i-lucide-alert-triangle',
  duplicated: 'i-lucide-copy',
  test_sent: 'i-lucide-send',
};

const detail = event => {
  const m = event.metadata || {};
  const parts = [];
  if (m.scheduled_at) parts.push(formatDateTime(m.scheduled_at, locale.value));
  if (m.recipients !== undefined)
    parts.push(
      t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.META.RECIPIENTS', {
        count: m.recipients,
      })
    );
  if (m.pending !== undefined)
    parts.push(
      t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.META.PENDING', { count: m.pending })
    );
  if (m.cancelled_recipients !== undefined)
    parts.push(
      t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.META.CANCELLED', {
        count: m.cancelled_recipients,
      })
    );
  if (m.error) parts.push(m.error);
  if (m.fields) parts.push(m.fields.join(', '));
  return parts.join(' · ');
};
</script>

<template>
  <div v-if="!events.length" class="py-8 text-sm text-center text-n-slate-11">
    {{ t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.EMPTY') }}
  </div>
  <ol v-else class="flex flex-col divide-y divide-n-weak">
    <li
      v-for="event in events"
      :key="event.id"
      class="flex items-start gap-3 py-3"
    >
      <span
        class="flex items-center justify-center size-7 rounded-full bg-n-alpha-2 text-n-slate-11 shrink-0"
      >
        <span
          :class="ICONS[event.action] || 'i-lucide-activity'"
          class="size-4"
        />
      </span>
      <div class="flex flex-col min-w-0 flex-1">
        <span class="text-sm text-n-slate-12">
          {{ t(`WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.ACTIONS.${event.action}`) }}
          <span class="text-n-slate-11">
            {{
              event.user
                ? t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.BY', {
                    name: event.user.name,
                  })
                : `· ${t('WASAPI_CAMPAIGNS.DETAIL.ACTIVITY.SYSTEM')}`
            }}
          </span>
        </span>
        <span v-if="detail(event)" class="text-xs text-n-slate-11 truncate">{{
          detail(event)
        }}</span>
      </div>
      <span class="text-xs text-n-slate-10 whitespace-nowrap">{{
        formatDateTime(event.created_at, locale)
      }}</span>
    </li>
  </ol>
</template>
